module.exports = __webpack_public_path__ + "static/media/wood.0b6d9d2f.jpeg";